import styled from '@emotion/styled'

export const ClearIconWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  cursor: pointer;
  pointer-events: auto;
`
